import { Skeleton } from '@/components/ui/skeleton';

export function PageSkeleton() {
	return (
		<div className="flex h-full flex-col">
			{/* Header skeleton */}
			<div className="flex items-center justify-between border-b px-3 py-3">
				<div className="flex items-center gap-2">
					<Skeleton className="size-7 rounded-md" />
					<Skeleton className="h-1 w-px" />
					<Skeleton className="h-5 w-32" />
				</div>
				<Skeleton className="h-8 w-24 rounded-md" />
			</div>
			{/* Content skeleton */}
			<div className="flex flex-col gap-4 p-4">
				<div className="flex gap-4">
					<Skeleton className="h-28 flex-1 rounded-xl" />
					<Skeleton className="h-28 flex-1 rounded-xl" />
					<Skeleton className="hidden h-28 flex-1 rounded-xl md:block" />
				</div>
				<Skeleton className="h-64 w-full rounded-xl" />
			</div>
		</div>
	);
}
